
import wallpaper from '../pages/img/wallpaper.jpg';

const Projects = () => {
    return ( 
        <main className="min-w-full h-screen pt-10 flex justify-center items-center">
            <h1 className='font-fonts text-3xl font-bold text-gray-700'>I am developing this page!!!</h1>
        </main>
     );
}
 
export default Projects;